import {SC_ConfirmationLevelEnum} from "./enums/SC_ConfirmationLevel";
import {SC_BasicNote} from "./notes/SC_BasicNote";
import {SC_BasicNotefromAPI} from "./notes/NoteUtils";
import {SC_User} from "./SC_User";

export class SC_WorkorderConfirmationNote {
    static inputKeys = {
        confirmNote: 'confirm_note',
        confirmNoteActual: 'confirm_note_actual',
        transitionStart: 'transition_start',
        transitionEnd: 'transition_end',
        spokenTo: 'spoken_to',
    } as const;

    confirmNote: number | null;
    confirmBackingNote: SC_BasicNote | null;
    transitionStart: SC_ConfirmationLevelEnum | null;
    transitionEnd: SC_ConfirmationLevelEnum | null;
    spokenTo: string | null;

    constructor({
        confirmNote = null,
        confirmBackingNote = null,
        transitionStart = null,
        transitionEnd = null,
        spokenTo = null,
    } = {}) {
        this.confirmNote = confirmNote;
        this.confirmBackingNote = confirmBackingNote;
        this.transitionStart = transitionStart;
        this.transitionEnd = transitionEnd;
        this.spokenTo = spokenTo;
    }

    static fromAPI(jsonin: Record<string, any>, usersCache?: SC_User[]): SC_WorkorderConfirmationNote {
        return new SC_WorkorderConfirmationNote({
            confirmNote: jsonin[SC_WorkorderConfirmationNote.inputKeys.confirmNote] ?? null,
            confirmBackingNote: jsonin[SC_WorkorderConfirmationNote.inputKeys.confirmNoteActual] ? SC_BasicNotefromAPI(jsonin[SC_WorkorderConfirmationNote.inputKeys.confirmNoteActual], usersCache) : null,
            transitionStart: jsonin[SC_WorkorderConfirmationNote.inputKeys.transitionStart] ? SC_ConfirmationLevelEnum.fromAPI(jsonin[SC_WorkorderConfirmationNote.inputKeys.transitionStart]) : null,
            transitionEnd: SC_ConfirmationLevelEnum.fromAPI(jsonin[SC_WorkorderConfirmationNote.inputKeys.transitionEnd]),
            spokenTo: jsonin[SC_WorkorderConfirmationNote.inputKeys.spokenTo] ?? null,
        });
    }

    toAPI(): Record<string, unknown> {
        return {
            [SC_WorkorderConfirmationNote.inputKeys.confirmNote]: this.confirmNote,
            [SC_WorkorderConfirmationNote.inputKeys.transitionStart]: this.transitionStart?.toAPI() ?? null,
            [SC_WorkorderConfirmationNote.inputKeys.transitionEnd]: this.transitionEnd?.toAPI(),
            [SC_WorkorderConfirmationNote.inputKeys.spokenTo]: this.spokenTo ?? null,
        };
    }

    clone(): SC_WorkorderConfirmationNote {
        return new SC_WorkorderConfirmationNote({
            confirmNote: this.confirmNote,
            confirmBackingNote: this.confirmBackingNote,
            transitionStart: this.transitionStart,
            transitionEnd: this.transitionEnd,
            spokenTo: this.spokenTo,
        });
    }

    merge(other: SC_WorkorderConfirmationNote): SC_WorkorderConfirmationNote {
        if (other.confirmNote !== null) this.confirmNote = other.confirmNote;
        if (other.confirmBackingNote !== null) this.confirmBackingNote = other.confirmBackingNote;
        if (other.transitionStart !== null) this.transitionStart = other.transitionStart;
        if (other.transitionEnd !== null) this.transitionEnd = other.transitionEnd;
        if (other.spokenTo !== null) this.spokenTo = other.spokenTo;

        return this;
    }

    equals(other: SC_WorkorderConfirmationNote): boolean {
        return this.confirmNote === other.confirmNote &&
            this.transitionStart?.is(other.transitionStart?.toAPI() ?? 1) &&
            this.transitionEnd?.is(other.transitionEnd?.toAPI() ?? 1) &&
            this.spokenTo === other.spokenTo;
    }

    scavengeUsers(users: SC_User[]): void {
        this.confirmBackingNote.scavengeUsers(users)
    }

    get isBackwards(): boolean {
        if (!this.transitionStart)
            return false;
        return this.transitionEnd.toAPI() <= this.transitionStart.toAPI();
    }
}
